import React, { useState, useRef } from "react";
import PropTypes from "prop-types";

import axios from 'axios';

import {
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row,
} from "reactstrap";
import { Form } from "@unform/web";
import ReactInputMask from "react-input-mask";
import {
	AddressField,
	InputField,
	StreetInputField,
} from "./styles";
import Input from "~/components/Form/Input";
import { toast } from "react-hot-toast";
import api from "~/services/api";

const CreateAddressModal = (props) => {
	const {
		toggleModalCreateUser,
		isModalCreateAddressOpened,
		user,
		getUserInfo,
		item,
		setHasCreatedAddress,
	} = props;
	const [validCep, setValidCep] = useState(true);
	const formRef = useRef(null);

	async function handleCreateUser(data) {
		if (user.delivery_info.cep_required && data.zip_code === "") {
			toast.error("CEP obrigatório");
			return;
		}
		try {
			await api.post("/restaurants/buyer/delivery-addresses", {
				country: "BR",
				state: data.state,
				buyer_id: item.buyer.id,
				city: data.city,
				complement: data.complement,
				neighborhood: data.neighborhood,
				number: data.number,
				reference: data.reference,
				street: data.street,
				zip_code: data.zip_code,
			});

			getUserInfo();
			toggleModalCreateUser();
			setHasCreatedAddress(true);
		} catch (error) {
			toast.error("Erro ao adicionar novo endereço");
			console.log(error);
		}
	}

	async function handleSearchCep(e) {
		if (e.target.value.charAt(8) !== "_") {
			const cep = e.target.value.replace("-", "").replace(".", "");

      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);

			if (!response.data.erro) {
				const streetInput = formRef.current.getFieldRef("street");
				const neighboorhoodInput = formRef.current.getFieldRef("neighborhood");
				const cityInput = formRef.current.getFieldRef("city");
				const stateInput = formRef.current.getFieldRef("state");
				streetInput.value = response.data.logradouro;
				neighboorhoodInput.value = response.data.bairro;
				cityInput.value = response.data.localidade;
				stateInput.value = response.data.uf;
				setValidCep(true);
			} else {
				const streetInput = formRef.current.getFieldRef("street");
				const neighboorhoodInput = formRef.current.getFieldRef("neighborhood");
				const cityInput = formRef.current.getFieldRef("city");
				setValidCep(false);
				streetInput.value = "";
				neighboorhoodInput.value = "";
				cityInput.value = "";
			}
		}
	}

	console.log("CreateAddressModal", props);
	return (
		<Modal isOpen={isModalCreateAddressOpened} toggle={toggleModalCreateUser}>
			<Form onSubmit={handleCreateUser} ref={formRef}>
				<ModalHeader>Adicionar endereço</ModalHeader>
				<ModalBody>
					<AddressField>
						<ReactInputMask
							mask="99999-999"
							onChange={(e) => handleSearchCep(e)}
						>
							<Input name="zip_code" placeHolder="CEP" />
						</ReactInputMask>
						{!validCep && (
							<Row>
								<p style={{ color: "red", textAlign: "right" }}>
                    CEP inválido.
								</p>
							</Row>
						)}
						<StreetInputField>
							{" "}
							<InputField>
								<Input
									type="text"
									placeholder="Digite sua rua ..."
									name="street"
									id="street"
								/>
							</InputField>
							<InputField>
								<Input
									type="text"
									placeholder="Número"
									name="number"
									id="number"
								/>
							</InputField>
						</StreetInputField>

						<Input type="text" placeholder="Bairro" name="neighborhood" />

						<Input name="city" placeHolder="Cidade" />
						<Input name="state" placeHolder="Estado" />

						<Input
							type="text"
							name="complement"
							placeholder="Ex: Casa 3, fundos"
						/>

						<Input
							type="text"
							name="reference"
							placeholder="Ex: Prox. ao mercado x"
						/>
					</AddressField>
				</ModalBody>
				<ModalFooter>
					<button
						className="btn btn-danger"
						type="button"
						onClick={toggleModalCreateUser}
					>
              Cancelar
					</button>
					<button className="btn btn-success" type="submit">
              Salvar
					</button>
				</ModalFooter>
			</Form>
		</Modal>
	);
};

CreateAddressModal.propTypes = {
	toggleModalCreateUser: PropTypes.func.isRequired,
	isModalCreateAddressOpened: PropTypes.bool.isRequired,
	user: PropTypes.object.isRequired,
	setDeliveryMethod: PropTypes.func.isRequired,
	getUserInfo: PropTypes.func.isRequired,
	item: PropTypes.object.isRequired,
	setHasCreatedAddress: PropTypes.func.isRequired,
};

export default CreateAddressModal;